import { Reveal } from "./Reveal";

const items = [
  {
    id: "battery-scrap",
    title: "Battery Scrap",
    body: "Used and spent lead-acid batteries (ULAB) collected through a safe, compliant channel.",
    image: "/buy-scrap.png",
    isri: null,
  },
  {
    id: "lead-scrap",
    title: "Lead Scrap",
    body: "Lead-acid battery plates, grids, lugs and mixed soft-lead scrap from industrial sources.",
    image: "/lead-scrap.png",
    isri: "ISRI: Racks · Radio",
  },
  {
    id: "remelted-lead",
    title: "Remelted Lead",
    body: "Remelted lead blocks and secondary lead ready for refining into finished product.",
    image: "/remelted-lead.png",
    isri: null,
  },
];

const Card = ({ it }) => (
  <div
    data-testid={`buy-${it.id}`}
    data-cursor="view"
    className="group overflow-hidden rounded-2xl border border-[var(--mx-line)] bg-[var(--mx-surface)] shadow-[0_20px_60px_-50px_rgba(27,23,20,0.5)] transition-[transform,box-shadow] duration-500 hover:-translate-y-1 hover:shadow-[0_30px_70px_-45px_rgba(27,23,20,0.45)]"
  >
    <div className="relative aspect-[4/3] overflow-hidden bg-[var(--mx-surface-2)]">
      <img
        src={it.image}
        alt={it.title}
        className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
      />
      {it.isri && (
        <span className="absolute right-4 top-4 rounded-full bg-[var(--mx-bg)]/85 px-3 py-1 font-mono-tech text-[10px] uppercase tracking-widest text-[var(--mx-copper)] backdrop-blur-md">
          {it.isri}
        </span>
      )}
    </div>
    <div className="p-7 md:p-8">
      <h3 className="font-display text-2xl font-extrabold uppercase tracking-tight text-[var(--mx-ink)] md:text-3xl">
        {it.title}
      </h3>
      <p className="mt-3 text-sm leading-relaxed text-[var(--mx-ink-2)]">
        {it.body}
      </p>
    </div>
  </div>
);

export const WhatWeBuy = () => (
  <section
    id="buy"
    data-testid="buy-section"
    className="border-y border-[var(--mx-line)] bg-[var(--mx-surface-2)]"
  >
    <div className="mx-auto max-w-[1400px] px-6 py-28 md:px-10 md:py-40">
      <Reveal>
        <div className="mb-14 flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
          <div>
            <div className="mb-5 flex items-center gap-4 font-mono-tech text-xs uppercase tracking-[0.25em] text-[var(--mx-ink-2)]">
              <span className="h-px w-10 bg-[var(--mx-copper)]" />
              02 — What We Buy
            </div>
            <h2 className="font-display text-5xl font-black uppercase leading-[0.9] tracking-tighter text-[var(--mx-ink)] md:text-7xl">
              Feedstock we <span className="text-metal">source</span>
            </h2>
          </div>
          <p className="inline-flex items-center gap-2 self-start rounded-full border border-[var(--mx-copper)]/30 bg-[var(--mx-copper)]/10 px-4 py-2 font-mono-tech text-[11px] uppercase tracking-widest text-[var(--mx-copper)]">
            Currently sourcing
          </p>
        </div>
      </Reveal>

      <Reveal delay={0.1}>
        <div className="grid grid-cols-1 gap-6 md:grid-cols-3">
          {items.map((it) => (
            <Card key={it.id} it={it} />
          ))}
        </div>
      </Reveal>
    </div>
  </section>
);

export default WhatWeBuy;
